import { render, staticRenderFns } from "./MessageType.vue?vue&type=template&id=23b77ff9&"
import script from "./MessageType.vue?vue&type=script&lang=js&"
export * from "./MessageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports